export const AnalysePage = () => {
  return <>Analyse</>
}
